// import React, { Fragment, useEffect, useState, useRef, useCallback } from 'react';
// import {
//   flexRender,
//   getCoreRowModel,
//   getSortedRowModel,
//   useReactTable,
//   getFilteredRowModel,
//   getPaginationRowModel,
//   getFacetedUniqueValues
// } from '@tanstack/react-table';
// import { useVirtual } from '@tanstack/react-virtual';
// import { ArrowPathIcon, PencilIcon, TrashIcon, PlusCircleIcon, FunnelIcon, EllipsisHorizontalIcon } from '@heroicons/react/24/outline';
// import { initialpageSize } from '../Common/Contants';
// import InputModal from '../Common/InputModal';
// import Popup from '../Common/Popup';
// import ConfirmationPopup from '../Common/ConfirmationPopup';
// import axios from 'axios';
// import { API_URL } from '../../imports'
// import { DebouncedInput, SelectTextFilterWithAllOption, StatusAdminFilter } from '../Common/Filters';
// import FetchingDataLoader from '../Common/FetchingDataLoader';
// import { handleApiError } from '../Common/APIUtils';
// import PageSizeDropdown from '../Common/PageSizeDropdown';
// import { formattedDate } from '../Common/CommonUtils';
// import { Menu, Transition } from '@headlessui/react';
// import { Portal } from "react-portal";
// import Pagination from '../Common/Pagination';

// export default function ProjectGroup() {
//   let [isOpen, setIsOpen] = useState(false);
//   let [rowData, setRowData] = useState([]);
//   let [edit, setEdit] = useState(false);
//   const [Loader, setLoader] = useState(true)
//   let [isOpenPopup, setIsOpenPopup] = useState(false);
//   let [msg, setMsg] = useState(false);
//   let [isSuccess, setIsSuccess] = useState(false);
//   let [client, setClient] = useState([]);
//   const [dropdownPosition, setDropdownPosition] = useState({ top: 0 });
//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const buttonRefs = useRef({});
//   const dropdownRef = useRef(null);

//   const calculatePosition = useCallback((id) => {
//     const buttonRef = buttonRefs.current[id];
//     if (buttonRef) {
//         const rect = buttonRef.getBoundingClientRect();
//         setDropdownPosition({
//             top: rect.bottom + window.scrollY,
//         });
//         setActiveDropdown((prev) => (prev === id ? null : id));
//     }
// }, []);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setActiveDropdown(null);
//       }
//     };
//     const handleKeyDown = (event) => {
//       const keysToCloseDropdown = ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp'];
//       if (keysToCloseDropdown.includes(event.key)) {
//         setActiveDropdown(null);
//       }
//     };
//     const handleScroll = () => {
//       setActiveDropdown(null);
//     };
  
//     if (activeDropdown !== null) {
//       document.addEventListener("mousedown", handleClickOutside);
//       document.addEventListener("keydown", handleKeyDown);
//       window.addEventListener("scroll", handleScroll, true);
//     }
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//       document.removeEventListener("keydown", handleKeyDown);
//       window.removeEventListener("scroll", handleScroll, true);
//     };
//   }, [activeDropdown]);

//   function closePopup() {
//     setIsOpenPopup(false);
//   }

//   function openPopup() {
//     setIsOpenPopup(true);
//   }

//   function closeModal() {
//     setIsOpen(false);
//     setRowData([]);
//   }

//   function openModal(e, option) {
//     setRowData(e);
//     if (option === 'edit') {
//       setEdit(true);
//     }
//     else if (option === 'create') {
//       setEdit(false);
//     }
//     setIsOpen(true);
//   }

//   const ReloadData = async (loadprops) => {
//     setLoader(loadprops);
//     axios
//       .get(`${API_URL}/projectgroup`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//         },
//         params: {
//           client: sessionStorage.getItem('client')
//         }
//       })
//       .then((response) => {
//         setData(response.data.data);
//       })
//       .catch((error) => {
//         const errorMessage = handleApiError(error);
//         setMsg(errorMessage);
//         openPopup();
//       })
//       .finally(() => {
//         setTimeout(() => {
//           setLoader(false);
//         }, 100);
//       });
//   };

//   const handleCreateState = async () => {
//     setIsOpen(false);
//     let create_form = { proj_grp_name: rowData.proj_grp_name, ...(localStorage.getItem('role') === 'ADMIN' && { client_code: rowData.client_code }) };
//     try {
//       await axios
//         .post(`${API_URL}/projectgroup`, create_form, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//           },
//           params: {
//             client: sessionStorage.getItem('client')
//           }
//         })
//         .then((response) => {
//           setMsg(response.data.message);
//           setIsSuccess(true);
//           ReloadData(false);
//           setIsOpenPopup(true);
//         });
//     } catch (error) {
//       const errorMessage = handleApiError(error);
//       setMsg(errorMessage);
//       setIsSuccess(false);
//       setIsOpenPopup(true);
//     }
//   };

//   const handleEditState = async () => {
//     let statu = { proj_grp_name: rowData.proj_grp_name, ...(localStorage.getItem('role') === 'ADMIN' && { client_code: rowData.client_code }) };
//     try {
//       await axios
//         .patch(`${API_URL}/projectgroup/${rowData.proj_grp_code}`, statu, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//           },
//         })
//         .then((response) => {
//           setIsOpen(false);
//           setMsg(response.data.message);
//           setIsSuccess(true);
//           ReloadData(false);
//           setIsOpenPopup(true);
//         });
//     } catch (error) {
//       setIsOpen(false);
//       const errorMessage = handleApiError(error);
//       setMsg(errorMessage);
//       setIsSuccess(false);
//       setIsOpenPopup(true);
//     }
//   };

//   let [isOpenStatusModal, setIsOpenStatusModal] = useState(false);
//   let [modalTitle, setModalTitle] = useState('');

//   function closeStatusModal() {
//     setIsOpenStatusModal(false);
//   }

//   function openStatusModal(e) {
//     setRowData(e);
//     setModalTitle(`Update Project Group Status - ${e.proj_grp_code}`)
//     setIsOpenStatusModal(true);
//   }

//   const handleStatusState = async () => {
//     let statusData = { status: rowData.status === false || rowData.status === 'false' ? false : true };
//     try {
//       await axios
//         .patch(`${API_URL}/projectgroup/status/${rowData.proj_grp_code}`, statusData, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//           },
//         })
//         .then((response) => {
//           setIsOpenStatusModal(false);
//           setMsg(response.data.message);
//           setIsSuccess(true);
//           ReloadData(false);
//           setIsOpenPopup(true);
//         });
//     } catch (error) {
//       setIsOpenStatusModal(false);
//       const errorMessage = handleApiError(error);
//       setMsg(errorMessage);
//       setIsSuccess(false);
//       setIsOpenPopup(true);
//     }
//   };

//   const [isOpenConfirmPopup, setIsOpenConfirmPopup] = useState(false);
//   const [confirmationMsg, setConfirmationMsg] = useState("");

//   function closeConfirmPopup() {
//     setIsOpenConfirmPopup(false);
//   }

//   function openConfirmPopup(e) {
//     setRowData(e);
//     setConfirmationMsg(`Are you sure that you want to delete project group - ${e.proj_grp_code} ?`)
//     setIsOpenConfirmPopup(true);
//   }

//   const handleDeleteState = async () => {
//     try {
//       await axios
//         .delete(`${API_URL}/projectgroup/${rowData.proj_grp_code}`, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//           },
//         })
//         .then((response) => {
//           setIsOpenConfirmPopup(false);
//           setMsg(response.data.message);
//           setIsSuccess(true);
//           ReloadData(false);
//           setIsOpenPopup(true);
//         });
//     } catch (error) {
//       setIsOpenConfirmPopup(false);
//       const errorMessage = handleApiError(error);
//       setMsg(errorMessage);
//       setIsSuccess(false);
//       setIsOpenPopup(true);
//     }
//   };

//   const [sorting, setSorting] = React.useState([]);

//   const columns = React.useMemo(
//     () => [
//       {
//         accessorKey: 'index',
//         enableColumnFilter: false,
//         enableSorting: false,
//         size: 50,
//         header: '#',
//         cell: ({ row }) => <center>{row.index + 1}</center>,
//       },
//       localStorage.getItem('role') === 'ADMIN' && {
//         accessorKey: 'client_name',
//         enableColumnFilter: true,
//         size: 100,
//         header: 'Client'
//       },
//       {
//         accessorKey: 'proj_grp_name',
//         enableColumnFilter: false,
//         size: 250,
//         header: () => <span>Group Name</span>
//       },
//       {
//         accessorKey: 'proj_grp_code',
//         enableColumnFilter: false,
//         size: 250,
//         header: () => <span>Group Code</span>,
//       },
//       {
//         accessorKey: 'creation_date',
//         enableColumnFilter: false,
//         size: 300,
//         header: 'Created Date',
//         cell: ({ row }) => (
//           <div>{formattedDate(row.original.creation_date)}</div>
//         )
//       },
//       {
//         accessorKey: 'creation_by',
//         enableColumnFilter: false,
//         size: 50,
//         header: 'Created By',
//       },
//       {
//         accessorKey: 'status',
//         header: 'Status',
//         size: 50,
//         enableColumnFilter: true,
//         enableSorting: false,
//         cell: ({ row }) => (
//           <div className='flex justify-center'><div onClick={() => openStatusModal(row.original)} className={`${row.original.status === true ? 'bg-green-300  text-green-900' : 'bg-red-300 text-red-900'} text-xs w-fit px-2 py-1 font-bold rounded-xl cursor-default lg:cursor-pointer`}>{row.original.status === true ? "Active" : "Inactive"}</div></div>
//         )
//       },
//       {
//         accessorKey: 'id',
//         header: 'Actions',
//         size: 50,
//         enableColumnFilter: false,
//         enableSorting: false,
//         cell: ({ row }) => {
//           const clientMatch = client?.find((client) => client.client_code === row.original.client_code);
//           return (
//           <div className='flex gap-2 items-center justify-center'>
//             <Menu as="div">
//               <div ref={(el) => (buttonRefs.current[row.original.id] = el)}>
//                 <Menu.Button className="border bg-gray-50 rounded-md p-1 text-blue-800 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     calculatePosition(row.original.id)
//                   }
//                   }
//                 >
//                   <EllipsisHorizontalIcon className="h-4 text-black" />
//                 </Menu.Button>
//               </div>
//               <Portal>
//                 <Transition
//                   as={Fragment}
//                   show={activeDropdown === row.original.id}
//                   enter="transition ease-out duration-100"
//                   enterFrom="transform opacity-0 scale-95"
//                   enterTo="transform opacity-100 scale-100"
//                   leave="transition ease-in duration-75"
//                   leaveFrom="transform opacity-100 scale-100"
//                   leaveTo="transform opacity-0 scale-95"
//                 >
//                   <Menu.Items className="absolute z-30 right-8 md:right-12 mt-1 w-fit rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
//                     style={{
//                       top: `${dropdownPosition.top}px`,
//                     }}
//                     ref={dropdownRef}
//                   >
//                     <button
//                       className="flex items-center px-4 py-2 hover:bg-gray-200 hover:text-blue-800 w-full text-sm disabled:text-gray-400"
//                       disabled={!clientMatch || row.original.status===false}
//                       onClick={() => {
//                         openModal(row.original, "edit")
//                         setActiveDropdown(null)
//                       }}
//                     >
//                       <PencilIcon className={`h-4 ${(!clientMatch || row.original.status===false)?'text-gray-400':'text-blue-800'} mr-2`} />
//                       <span>Edit</span>
//                     </button>
//                     {localStorage.getItem('role') === 'ADMIN' &&
//                       <button className="flex items-center px-4 py-2 hover:bg-gray-200 hover:text-red-800 w-full text-sm"
//                         onClick={() => {
//                           openConfirmPopup(row.original)
//                           setActiveDropdown(null)
//                         }}>
//                         <TrashIcon className='h-4 text-red-800 mr-2' />
//                         <span>Delete</span>
//                       </button>}
//                   </Menu.Items>
//                 </Transition>
//               </Portal>
//             </Menu>
//           </div>
//         )}
//       },
//     ].filter(Boolean),
//     [client, activeDropdown, calculatePosition, dropdownPosition.top]
//   );

//   const [data, setData] = useState([]);

//   const [globalFilter, setGlobalFilter] = React.useState('');
//   const [pageIndex, setPageIndex] = React.useState(0);
//   const [pageSize, setPageSize] = React.useState(initialpageSize);


//   const pagination = React.useMemo(
//     () => ({
//       pageIndex,
//       pageSize,
//     }),
//     [pageIndex, pageSize]
//   )

//   const table = useReactTable({
//     data,
//     columns,
//     state: {
//       sorting,
//       pagination,
//       globalFilter
//     },
//     onGlobalFilterChange: setGlobalFilter,
//     onSortingChange: setSorting,
//     getCoreRowModel: getCoreRowModel(),
//     getSortedRowModel: getSortedRowModel(),
//     getFilteredRowModel: getFilteredRowModel(),
//     getPaginationRowModel: getPaginationRowModel(),
//     getFacetedUniqueValues: getFacetedUniqueValues()
//   });

//   const tableContainerRef = React.useRef(null);
//   // Modify the pagination section
//   const pageCount = Math.ceil(data.length / pageSize);
//   const pageNumbers = [];

//   for (let i = 0; i < pageCount; i++) {
//     pageNumbers.push(i);
//   }

//   const handlePageChange = (e) => {
//     const newPageSize = Number(e.target.value);
//     setPageSize(newPageSize);
//     setPageIndex(0)
//   };

//   const { rows } = table.getRowModel();
//   const rowVirtualizer = useVirtual({
//     parentRef: tableContainerRef,
//     size: rows.length,
//     overscan: pageSize,
//   });
//   const { virtualItems: virtualRows, totalSize } = rowVirtualizer;

//   const paddingTop = virtualRows.length > 0 ? virtualRows[0]?.start || 0 : 0;
//   const paddingBottom =
//     virtualRows.length > 0
//       ? totalSize - (virtualRows[virtualRows.length - 1]?.end || 0)
//       : 0;

//   const renderTableCellIndex = (row) => {
//     return (
//       table.getFilteredRowModel().rows.indexOf(row) + 1 ||
//       table.getSortedRowModel().rows.indexOf(row) + 1 ||
//       row.index + 1
//     );
//   };

//   useEffect(() => {
//     const fetchInitialData = async () => {
//       axios
//         .get(`${API_URL}/projectgroup`, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//           },
//           params: {
//             client: sessionStorage.getItem('client')
//           }
//         })
//         .then((response) => {
//           setData(response.data.data);
//         })
//         .catch((error) => {
//           const errorMessage = handleApiError(error);
//           setMsg(errorMessage);
//           openPopup();
//         })
//         .finally(() => {
//           setTimeout(() => {
//             setLoader(false);
//           }, 100);
//         });
//     };
//     const fetchClientData = async () => {
//       axios
//         .get(`${API_URL}/clients`, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
//           },
//         })
//         .then((response) => {
//           const filteredClients = response.data.data.filter(client => client.status === true);
//           setClient(filteredClients);
//         })
//         .catch((error) => {
//           const errorMessage = handleApiError(error);
//           setMsg(errorMessage);
//           openPopup();
//         })
//         .finally(() => {
//           setTimeout(() => {
//             setLoader(false);
//           }, 100);
//         });
//     };
//     fetchClientData();
//     fetchInitialData();
//   }, []);

//   return (
//     <div className="border rounded-lg bg-white font-GoogleSans tracking-wider overflow-hidden">
//       <ConfirmationPopup
//         isOpenConfirmPopup={isOpenConfirmPopup}
//         confirmationMsg={confirmationMsg}
//         closeConfirmPopup={closeConfirmPopup}
//         onStateChange={handleDeleteState}
//       />
//       <Popup
//         isOpen={isOpenPopup}
//         msg={msg}
//         closeModal={closePopup}
//         isSuccess={isSuccess}
//       />
//       <InputModal isOpen={isOpen} closeModal={closeModal} title={edit === false ? 'Create project group' : 'Edit project group'} savefn={edit === false ? handleCreateState : handleEditState}
//         modalInputs={
//           <div className='space-y-4'>
//             {localStorage.getItem('role') === 'ADMIN' &&
//               <div>
//                 <label htmlFor="client" className="block text-sm font-medium leading-6 text-gray-900">
//                   Client
//                 </label>
//                 <select
//                   id="client"
//                   name="client"
//                   required
//                   className="block w-auto md:w-full rounded-md border-0 py-2 mt-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs lg:max-w-full sm:text-sm sm:leading-6"
//                   value={rowData.client_code}
//                   onChange={(e) => setRowData({ ...rowData, client_code: e.target.value })}
//                 >
//                   <option value="">Select Client</option>
//                   {client.map((item, index) => (
//                     <option key={index} value={item.client_code}>
//                       {item.client_name}
//                     </option>
//                   ))}
//                 </select>
//               </div>}
//             <div>
//               <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
//                 Group Name
//               </label>
//               <input type="text" className='block w-full rounded-md border py-1.5 mt-1 ring-0 sm:text-sm sm:leading-6' defaultValue={rowData.proj_grp_name} onChange={(e) => setRowData({ ...rowData, proj_grp_name: e.target.value })} />
//             </div>
//           </div>
//         }
//       />
//       <InputModal isOpen={isOpenStatusModal} closeModal={closeStatusModal} title={modalTitle} savefn={handleStatusState}
//         modalInputs={
//           <div className='flex gap-5'>
//             <div className="flex items-center gap-x-2">
//               <input
//                 id="status"
//                 name="status"
//                 type="radio"
//                 value="true"
//                 checked={rowData.status === true || rowData.status === "true"}
//                 onChange={(e) =>
//                   setRowData({
//                     ...rowData,
//                     status: e.target.value,
//                   })
//                 }
//                 autoFocus={false}
//                 className="h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none"
//               />
//               <label htmlFor="push-everything" className="block text-sm font-medium leading-6 text-gray-900">
//                 Active
//               </label>
//             </div>
//             <div className="flex items-center gap-x-2">
//               <input
//                 id="status"
//                 name="status"
//                 type="radio"
//                 value="false"
//                 checked={rowData.status === false || rowData.status === "false"}
//                 onChange={(e) =>
//                   setRowData({
//                     ...rowData,
//                     status: e.target.value,
//                   })
//                 }
//                 autoFocus={false}
//                 className="h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none"
//               />
//               <label htmlFor="push-email" className="block text-sm font-medium leading-6 text-gray-900">
//                 Inactive
//               </label>
//             </div>
//           </div>
//         }
//       />
//       <div className='flex justify-between m-3 gap-2'>
//         <div>
//           <DebouncedInput
//             value={globalFilter ?? ''}
//             onChange={value => setGlobalFilter(String(value))}
//             placeholder="Search..."
//           />
//         </div>
//         <div className='flex gap-2'>
//           <button className="rounded-md cursor-default lg:cursor-pointer p-2 inline-flex text-sm border-gray-300 border" onClick={() => ReloadData(true)}>
//             <ArrowPathIcon className='h-5 text-green-700' />
//           </button>
//           <Menu as="div" className="relative">
//             <div>
//               <Menu.Button className="relative justify-center border border-gray-300 rounded-md p-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer">
//                 <span className="absolute -inset-1.5" />
//                 <FunnelIcon className="h-5 w-auto" />
//               </Menu.Button>
//             </div>
//             <Transition
//               as={Fragment}
//               enter="transition ease-out duration-100"
//               enterFrom="transform opacity-0 scale-95"
//               enterTo="transform opacity-100 scale-100"
//               leave="transition ease-in duration-75"
//               leaveFrom="transform opacity-100 scale-100"
//               leaveTo="transform opacity-0 scale-95"
//             >
//               <Menu.Items className="fixed right-8 z-30 mt-3 w-fit px-2 pb-2 space-y-3 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
//                 <div>
//                   {data.length > 0 &&
//                     table
//                       .getHeaderGroups()
//                       .map((headerGroup) => (
//                         <div
//                           key={headerGroup.id}
//                           className="space-y-1"
//                         >
//                           {headerGroup.headers.map(
//                             (header) => (
//                               <div
//                                 key={header.id}
//                               >
//                                 {header.column.getCanFilter() &&
//                                   header.column.id === "status" ? (
//                                   <div>
//                                     <label
//                                       htmlFor="push-everything"
//                                       className="block text-xs font-bold tracking-widest leading-6 text-gray-400 ps-1"
//                                     >
//                                       Status
//                                     </label>
//                                     <StatusAdminFilter
//                                       column={
//                                         header.column
//                                       }
//                                       table={
//                                         table
//                                       }
//                                     />
//                                   </div>
//                                 ) : null}
//                                 {header.column.getCanFilter() &&
//                                   header.column
//                                     .id ===
//                                   "client_name" ? (
//                                   <div>
//                                     <label
//                                       htmlFor="push-everything"
//                                       className="block text-xs font-bold tracking-widest leading-6 text-gray-400 ps-1"
//                                     >
//                                       Client
//                                     </label>
//                                     <SelectTextFilterWithAllOption
//                                       column={
//                                         header.column
//                                       }
//                                       table={
//                                         table
//                                       }
//                                     />
//                                   </div>
//                                 ) : null}
//                               </div>
//                             )
//                           )}
//                         </div>
//                       ))}
//                 </div>
//               </Menu.Items>
//             </Transition>
//           </Menu>
//           <button className="rounded-md cursor-default lg:cursor-pointer p-2 inline-flex text-sm border-gray-300 border" onClick={() => openModal('e', 'create')}>
//             <PlusCircleIcon className='h-5' />
//           </button>
//         </div>
//       </div>
//       {Loader && <FetchingDataLoader />}
//       {!Loader &&
//         <>
//           <div ref={tableContainerRef} className='resp-table-h border-y overflow-auto relative'>
//             <table className='flex-inline w-full border-collapse'>
//               <thead className='bg-gray-100'>
//                 {table.getHeaderGroups().map((headerGroup) => (
//                   <tr key={headerGroup.id}>
//                     {headerGroup.headers.map((header) => {
//                       return (
//                         <th
//                           className='border p-2 whitespace-nowrap'
//                           key={header.id}
//                           colSpan={header.colSpan}
//                           style={{ width: header.getSize() }}
//                         >
//                           {header.isPlaceholder ? null : (
//                             <>
//                               <div
//                                 className={`${header.column.getCanSort()
//                                   ? 'cursor-pointer select-none justify-start'
//                                   : 'justify-center'
//                                   } flex`}
//                                 onClick={header.column.getToggleSortingHandler()}
//                               >
//                                 {flexRender(
//                                   header.column.columnDef.header,
//                                   header.getContext()
//                                 )}
//                                 {{
//                                   asc: ' 🔼',
//                                   desc: ' 🔽',
//                                 }[header.column.getIsSorted()] || null}
//                               </div>
//                             </>
//                           )}
//                         </th>
//                       );
//                     })}
//                   </tr>
//                 ))}
//               </thead>
//               <tbody>
//                 {
//                   rows.length === 0 ? (
//                     <tr>
//                       <td className='border p-2' colSpan={table.getHeaderGroups()[0].headers.length} style={{ textAlign: 'center' }}>
//                         No Data Found
//                       </td>
//                     </tr>
//                   ) :
//                     (
//                       <>
//                         {paddingTop > 0 && (
//                           <tr>
//                             <td className='border p-2' style={{ height: `${paddingTop}px` }} />
//                           </tr>
//                         )}
//                         {virtualRows.map((virtualRow) => {
//                           const row = rows[virtualRow.index];
//                           return (
//                             <tr key={row.id}>
//                               {row.getVisibleCells().map((cell) => {
//                                 return (
//                                   <td className='border p-2 whitespace-nowrap' key={cell.id}>
//                                     {cell.column.id === "index" && (
//                                       <center>{renderTableCellIndex(row)}</center>
//                                     )}
//                                     {cell.column.id !== "index" &&
//                                       flexRender(
//                                         cell.column
//                                           .columnDef
//                                           .cell,
//                                         cell.getContext()
//                                       )}
//                                   </td>
//                                 );
//                               })}
//                             </tr>
//                           );
//                         })}
//                         {paddingBottom > 0 && (
//                           <tr>
//                             <td className='border p-2' style={{ height: `${paddingBottom}px` }} />
//                           </tr>
//                         )}
//                       </>
//                     )
//                 }

//               </tbody>
//             </table>
//           </div>
//           {
//             rows.length > 0 && (
//               <div className='flex gap-1 flex-wrap md:flex-nowrap justify-between flex-row-reverse m-3'>
//                 {/* <nav className="isolate inline-flex -space-x-px mx-2 md:m-0 bg-white rounded-md md:shadow-sm text-gray-900" aria-label="Pagination">
//                   <button title='First Page' onClick={() => setPageIndex(0)}
//                     className="relative inline-flex items-center rounded-l-md px-2 py-2 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
//                   >
//                     <ChevronDoubleLeftIcon className="h-5 w-5" aria-hidden="true" />
//                   </button>
//                   <button title='Previous Page'
//                     onClick={() => setPageIndex(pageIndex - 1)}
//                     disabled={pageIndex === 0}
//                     aria-current="page"
//                     className="relative inline-flex items-center px-2 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
//                   >
//                     <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
//                   </button>
//                   {pageNumbers.length === 1 &&
//                     <button
//                       className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
//                       key={1}
//                       onClick={() => setPageIndex(0)}
//                     >
//                       {1}
//                     </button>
//                   }
//                   {pageNumbers.length > 1 && pageNumbers.map((pageNumber, index) => {
//                     if (pageNumber === 0 || pageNumber === table.getPageCount() - 1 || Math.abs(pageNumber - pageIndex) <= 1) {
//                       if (table.getPageCount() !== 0 && table.getPageCount() === 1 && table.getPageCount() === pageNumber) {
//                         return (
//                           <button
//                             className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
//                             key={index}
//                             onClick={() => setPageIndex(pageNumber - 1)}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       }
//                       else if (table.getPageCount() !== 1 && table.getPageCount() > pageNumber) {
//                         return (
//                           <button
//                             className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
//                             key={index}
//                             onClick={() => setPageIndex(pageNumber)}
//                           >
//                             {pageNumber + 1}
//                           </button>
//                         );
//                       }
//                       else if (table.getPageCount() === 0 && table.getPageCount() === pageNumber) {
//                         return (
//                           <button
//                             className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
//                             key={index}
//                             onClick={() => setPageIndex(0)}
//                           >
//                             {1}
//                           </button>
//                         );
//                       }
//                     } else if (pageNumber === 1 || pageNumber === table.getPageCount() - 2) {
//                       return <button className='relative inline-flex items-center px-4 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0' key={index}>...</button>;
//                     }
//                     return null;
//                   })}
//                   <button title='Next Page' onClick={() => setPageIndex(pageIndex + 1)} disabled={pageIndex === (table.getPageCount() - 1)}
//                     className="relative inline-flex items-center px-2 py-2 text-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
//                   >
//                     <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
//                   </button>
//                   <button title='Last Page' onClick={() => setPageIndex(table.getPageCount() - 1)}
//                     className="relative inline-flex items-center rounded-r-md px-2 py-2 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
//                   >
//                     <ChevronDoubleRightIcon className="h-5 w-5" aria-hidden="true" />
//                   </button>
//                 </nav> */}
//                 <Pagination
//                   pageIndex={pageIndex}
//                   setPageIndex={setPageIndex}
//                   pageNumbers={pageNumbers}
//                   pageCount={table.getPageCount()}
//                 />
//                 <PageSizeDropdown
//                   dataLength={table.getPrePaginationRowModel().rows.length}
//                   pageSize={pageSize}
//                   handlePageChange={handlePageChange}
//                   totalRows={table.getPrePaginationRowModel().rows.length}
//                 />
//               </div>
//             )
//           }
//         </>
//       }
//     </div>
//   );
// }

import React, { Fragment, useEffect, useState, useRef, useCallback } from 'react';
import {
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
  getFilteredRowModel,
  getPaginationRowModel,
  getFacetedUniqueValues
} from '@tanstack/react-table';
import { useVirtualizer } from '@tanstack/react-virtual';
import { ArrowPathIcon, PencilIcon, TrashIcon, PlusCircleIcon, FunnelIcon, EllipsisHorizontalIcon } from '@heroicons/react/24/outline';
import { initialpageSize } from '../Common/Contants';
import InputModal from '../Common/InputModal';
import Popup from '../Common/Popup';
import ConfirmationPopup from '../Common/ConfirmationPopup';
import axios from 'axios';
import { API_URL, FUNCTION_BASE_URL, FUNCTION_CODE, PROJECT_URL } from '../../imports'
import { DebouncedInput, SelectTextFilterWithAllOption, StatusAdminFilter } from '../Common/Filters';
import FetchingDataLoader from '../Common/FetchingDataLoader';
import { handleApiError } from '../Common/APIUtils';
import PageSizeDropdown from '../Common/PageSizeDropdown';
import { formattedDate } from '../Common/CommonUtils';
import { Menu, Transition } from '@headlessui/react';
import { Portal } from "react-portal";
import Pagination from '../Common/Pagination';

export default function ProjectGroup() {
  let [isOpen, setIsOpen] = useState(false);
  let [rowData, setRowData] = useState([]);
  let [edit, setEdit] = useState(false);
  const [Loader, setLoader] = useState(true)
  let [isOpenPopup, setIsOpenPopup] = useState(false);
  let [msg, setMsg] = useState(false);
  let [isSuccess, setIsSuccess] = useState(false);
  let [client, setClient] = useState([]);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0 });
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [projectGroups, setProjectGroups] = useState([]);
  console.log("UI Project Groups:", projectGroups);

  const buttonRefs = useRef({});
  const dropdownRef = useRef(null);
  const scrollRef = useRef(null);

  // Helper function to get user info
  const getUserInfo = () => ({
    // _id: localStorage.getItem("userid") || localStorage.getItem("_id") || "default_user_id",
    _id: sessionStorage.getItem("userid"),
    clientId: sessionStorage.getItem('client'),
    // role: localStorage.getItem('role') || "ProjectAdmin"
    role: sessionStorage.getItem('role') || "ProjectAdmin"
  });

  // console.log("PROJECT_URL =", PROJECT_URL);

  

  const calculatePosition = useCallback((id) => {
    const buttonRef = buttonRefs.current[id];
    if (buttonRef) {
      const rect = buttonRef.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + window.scrollY,
      });
      setActiveDropdown((prev) => (prev === id ? null : id));
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };
    const handleKeyDown = (event) => {
      const keysToCloseDropdown = ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp'];
      if (keysToCloseDropdown.includes(event.key)) {
        setActiveDropdown(null);
      }
    };
    const handleScroll = () => {
      setActiveDropdown(null);
    };

    if (activeDropdown !== null) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleKeyDown);
      window.addEventListener("scroll", handleScroll, true);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [activeDropdown]);

  function closePopup() {
    setIsOpenPopup(false);
  }

  function openPopup() {
    setIsOpenPopup(true);
  }

  function closeModal() {
    setIsOpen(false);
    setRowData([]);
  }

  function openModal(e, option) {
    setRowData(e);
    if (option === 'edit') {
      setEdit(true);
    }
    else if (option === 'create') {
      setEdit(false);
    }
    setIsOpen(true);
  }

  const ReloadData = async (loadprops) => {
    setLoader(loadprops);
    console.log("🚀 Reloading project groups...");
    axios
      .post(`${PROJECT_URL}/projects/groups/list`, {
        userInfo: getUserInfo(),
        payload: {}
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        }
      })
      .then((response) => {
        // setData(response.data);
        console.log("Full Response:", response);
        // console.log("Response Data:", response.data.data.project_grp_list || []);
        const groups = response.data || [];
        console.log("🚀 Groups:", groups);

        setProjectGroups(groups);
      })
      .catch((error) => {
        console.error("🚀 Error fetching project groups:", error);
        const errorMessage = handleApiError(error);
        setMsg(errorMessage);
        openPopup();
      })
      .finally(() => {
        setTimeout(() => {
          setLoader(false);
        }, 100);
      });
    // fetch(`${API_URL}/projects/groups/list`, {
    //   method: "POST",
    //   headers: {
    //     "Authorization": "Bearer " + localStorage.getItem("access_token"),
    //     "Content-Type": "application/json"
    //   },
    //   body: JSON.stringify({
    //     userInfo: {
    //       _id: localStorage.getItem("user_id"),
    //       clientId: sessionStorage.getItem("client"),
    //       role: localStorage.getItem("role")
    //     },
    //     payload: {}
    //   })
    // }).then(r => r.json()).then(data => {
    //   setData(data);
    //   setLoader(false);
    // })

  };
  
  // TEMPORARY TEST VERSION - Replace your ReloadData function
  // const ReloadData = async (loadprops) => {
  //   setLoader(loadprops);
  //   console.log("🧪 TEST MODE: Calling direct endpoint (bypassing APIM)");
  //   const CONTAINER_URL = "https://ixo-meghnadnext-app-pm-dev-01.calmfield-02780d18.centralindia.azurecontainerapps.io";
    
  //   // ✅ Construct the exact payload that APIM would send
  //   const testPayload = {
  //     userInfo: {
  //       _id: sessionStorage.getItem("userid"),
  //       clientId: sessionStorage.getItem('client'),
  //       role: sessionStorage.getItem('role') || "ProjectAdmin",
  //       rg_name: sessionStorage.getItem('resource_group') || localStorage.getItem('resource_group')
  //     },
  //     payload: {}
  //   };
    
  //   console.log("🧪 Test Payload:", testPayload);
    
  //   // ✅ Call the DIRECT test endpoint (no APIM)
  //   axios
  //     .post(`${CONTAINER_URL}/projects/groups/list-direct-test`, testPayload, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         // NO Authorization header needed for test endpoint
  //       }
  //     })
  //     .then((response) => {
  //       console.log("✅ Direct endpoint SUCCESS!");
  //       console.log("Full Response:", response);
  //       console.log("Response Data:", response.data);
        
  //       const groups = response.data || [];
  //       console.log("🚀 Groups:", groups);
  //       setProjectGroups(groups);
  //     })
  //     .catch((error) => {
  //       console.error("❌ Direct endpoint FAILED:", error);
  //       console.error("Error response:", error.response?.data);
  //       const errorMessage = handleApiError(error);
  //       setMsg(errorMessage);
  //       openPopup();
  //     })
  //     .finally(() => {
  //       setTimeout(() => {
  //         setLoader(false);
  //       }, 100);
  //     });
  // };

  const handleCreateState = async () => {
    // Validate required fields
    if (!rowData.name?.trim()) {
      setMsg("Group name is required");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }
    // Check for duplicate name
    const isDuplicate = projectGroups.some(
      group => group.name.toLowerCase().trim() === rowData.name?.toLowerCase().trim()
    );

    if (isDuplicate) {
      setMsg("A project group with this name already exists");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }
    setIsOpen(false);
    // let create_form = {
    //   userInfo: getUserInfo(),
    //   payload: {
    //     name: rowData.name,
    //     description: rowData.description || "",
    //     tags: rowData.tags || [],
    //     status: "active",
    //     ...(localStorage.getItem('role') === 'ADMIN' && { client_code: rowData.client_code })
    //   }
    // };
    let create_form = {
      name: rowData.name,
      description: rowData.description || "",
      tags: rowData.tags || [],
      status: "active",
      ...(localStorage.getItem('role') === 'ADMIN' && { client_code: rowData.client_code })
    };

    try {
      await axios
        .post(`${PROJECT_URL}/projects/groups/create`, create_form, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          }
        })
        .then((response) => {
          setMsg(response.data.message || "Group updated successfully");
          setIsSuccess(true);
          ReloadData(false);
          setIsOpenPopup(true);
        });
    } catch (error) {
      const errorMessage = handleApiError(error);
      setMsg(errorMessage);
      setIsSuccess(false);
      setIsOpenPopup(true);
    }
  };

  // const handleEditState = async () => {
  //   // let update_data = {
  //   //   userInfo: getUserInfo(),
  //   //   payload: {
  //   //     name: rowData.name,
  //   //     description: rowData.description || "",
  //   //     tags: rowData.tags || [],
  //   //     status: rowData.status === true ? "active" : "inactive"
  //   //   }
  //   const payload = {
  //     name: rowData.name,
  //     description: rowData.description || "",
  //     tags: rowData.tags || []
  //   };

  //   // ✔ Only include status if the user actually changed it
  //   if (rowData.status !== undefined) {
  //     payload.status = rowData.status === true ? "active" : "inactive";
  //   }

  //   let update_data = {
  //     userInfo: getUserInfo(),
  //     payload
  //   };

  //   try {
  //     await axios
  //       .put(`${PROJECT_URL}/projects/groups/${rowData.group_id}`, update_data, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //         },
  //       })
  //       .then((response) => {
  //         setIsOpen(false);
  //         setMsg(response.data.message || "Group updated successfully");
  //         setIsSuccess(true);
  //         ReloadData(false);
  //         setIsOpenPopup(true);
  //       });
  //   } catch (error) {
  //     setIsOpen(false);
  //     const errorMessage = handleApiError(error);
  //     setMsg(errorMessage);
  //     setIsSuccess(false);
  //     setIsOpenPopup(true);
  //   }
  // };

  const handleEditState = async () => {
    // Validate required fields
    if (!rowData.name?.trim()) {
      setMsg("Group name is required");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }
    // Check for duplicate name (excluding current group)
    const isDuplicate = projectGroups.some(
      group => group.group_id !== rowData.group_id && 
              group.name.toLowerCase().trim() === rowData.name.toLowerCase().trim()
    );

    if (isDuplicate) {
      setMsg("A project group with this name already exists");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }
    const payload = {
      name: rowData.name,
      description: rowData.description || "",
      tags: rowData.tags || []
    };

    // Only include status if it was actually changed (handles both string and boolean)
    if (rowData.status !== undefined) {
      payload.status =
        rowData.status === "active" || rowData.status === true
          ? "active"
          : "inactive";
    }

    // const update_data = {
    //   userInfo: getUserInfo(),
    //   payload
    // };

    const update_data = {
      payload
    };

    try {
      const response = await axios.put(
        `${PROJECT_URL}/projects/groups/${rowData.group_id}`,
        update_data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          }
        }
      );

      // Success handling
      setIsOpen(false);
      setMsg(response.data.message || "Group updated successfully");
      setIsSuccess(true);
      ReloadData(false);
      setIsOpenPopup(true);
    } catch (error) {
      // Error handling
      setIsOpen(false);
      const errorMessage = handleApiError(error);
      setMsg(errorMessage);
      setIsSuccess(false);
      setIsOpenPopup(true);
    }
  };


  let [isOpenStatusModal, setIsOpenStatusModal] = useState(false);
  let [modalTitle, setModalTitle] = useState('');

  function closeStatusModal() {
    setIsOpenStatusModal(false);
  }

  function openStatusModal(e) {
    // setRowData(e);
    setRowData({
      ...e,
      // ✅ Convert "active"/"inactive" string to match radio button values
      status: e.status === 'active' ? 'active' : 'inactive'
    });
    setModalTitle(`Update Project Group Status - ${e.group_id}`)
    setIsOpenStatusModal(true);
  }

  const handleStatusState = async () => {

    // Validation: Check if status is selected
    if (!rowData.status) {
      setMsg("Please select a status");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }

    // Validation: Check if status actually changed
    const originalStatus = projectGroups.find(item => item.group_id === rowData.group_id)?.status;
    if (rowData.status === originalStatus) {
      setIsOpenStatusModal(false);
      setMsg("No changes detected. Status remains the same.");
      setIsSuccess(false);
      setIsOpenPopup(true);
      return;
    }

    // let statusData = {
    //   userInfo: getUserInfo(),
    //   payload: {
    //     // status: rowData.status === false || rowData.status === 'false' ? "inactive" : "active"
    //     status: rowData.status === "active" ? "inactive" : "active"
    //   }
    // };

    // ✅ FIXED: Use the selected status value directly
    // let statusData = {
    //   userInfo: getUserInfo(),
    //   payload: {
    //     status: rowData.status // This should be "active" or "inactive" from radio selection
    //   }
    // };

    let statusData = {
      status: rowData.status
    };

    try {
      await axios
        .patch(`${PROJECT_URL}/projects/groups/${rowData.group_id}/status`, statusData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((response) => {
          setIsOpenStatusModal(false);
          setMsg(response.data.message);
          setIsSuccess(true);
          ReloadData(false);
          setIsOpenPopup(true);
        });
    } catch (error) {
      setIsOpenStatusModal(false);
      const errorMessage = handleApiError(error);
      setMsg(errorMessage);
      setIsSuccess(false);
      setIsOpenPopup(true);
    }
  };

  const [isOpenConfirmPopup, setIsOpenConfirmPopup] = useState(false);
  const [confirmationMsg, setConfirmationMsg] = useState("");

  function closeConfirmPopup() {
    setIsOpenConfirmPopup(false);
  }

  function openConfirmPopup(e) {
    setRowData(e);
    setConfirmationMsg(`Are you sure that you want to delete project group - ${e.group_id} ?`)
    setIsOpenConfirmPopup(true);
  }

  const handleDeleteState = async () => {
    try {
      await axios
        .delete(`${PROJECT_URL}/projects/groups/${rowData.group_id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((response) => {
          setIsOpenConfirmPopup(false);
          setMsg(response.data.message);
          setIsSuccess(true);
          ReloadData(false);
          setIsOpenPopup(true);
        });
    } catch (error) {
      setIsOpenConfirmPopup(false);
      const errorMessage = handleApiError(error);
      setMsg(errorMessage);
      setIsSuccess(false);
      setIsOpenPopup(true);
    }
  };

  const statusFilterFn = (row, columnId, filterValue) => {
    if (filterValue === '' || filterValue === undefined) {
      return true;
    }
    
    const rowValue = row.getValue(columnId);
    
    // Handle boolean filterValue from StatusAdminFilter
    if (typeof filterValue === 'boolean') {
      return rowValue === (filterValue ? 'active' : 'inactive');
    }
    
    // Handle string filterValue
    if (typeof filterValue === 'string') {
      return rowValue === filterValue;
    }
    
    return true;
  };

  const clientFilterFn = (row, columnId, filterValue) => {
    if (filterValue === '' || filterValue === undefined) {
      return true;
    }
    
    const rowValue = row.getValue(columnId);
    return rowValue === filterValue;
  };

  const [sorting, setSorting] = React.useState([]);

  const columns = React.useMemo(
    () => [
      {
        accessorKey: 'index',
        enableColumnFilter: false,
        enableSorting: false,
        size: 50,
        header: '#',
        cell: ({ row }) => <center>{row.index + 1}</center>,
      },
      localStorage.getItem('role') === 'ADMIN' && {
        accessorKey: 'client_id',
        enableColumnFilter: true,
        size: 100,
        header: 'Client',
        filterFn: clientFilterFn,
      },
      {
        accessorKey: 'name',
        enableColumnFilter: false,
        size: 250,
        header: () => <span>Group Name</span>
      },
      {
        accessorKey: 'group_id',
        enableColumnFilter: false,
        size: 250,
        header: () => <span>Group Code</span>,
      },
      // {
      //   accessorKey: 'tags',
      //   enableColumnFilter: false,
      //   size: 200,
      //   header: () => <span>Tags</span>,
      //   cell: ({ row }) => (
      //     <div className="text-start">
      //       {row.original.tags && row.original.tags.length > 0 ? (
      //         row.original.tags.map((tag, index) => (
      //           <span key={index} className="inline-flex items-center rounded-md bg-blue-50 px-2 py-0 m-1 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
      //             {tag}
      //           </span>
      //         ))
      //       ) : (
      //         <span className="text-gray-400">No tags</span>
      //       )}
      //     </div>
      //   ),
      // },
      {
        accessorKey: 'project_count',
        enableColumnFilter: false,
        size: 100,
        header: 'Projects',
        cell: ({ row }) => (
          <div className="text-center">
            <span className="inline-flex items-center rounded-full bg-indigo-100 px-3 py-1 text-sm font-medium text-indigo-800">
              {row.original.project_count || 0}
            </span>
          </div>
        ),
      },
      {
        accessorKey: 'created_at',
        enableColumnFilter: false,
        size: 300,
        header: 'Created Date',
        cell: ({ row }) => (
          <div>{formattedDate(row.original.created_at)}</div>
        )
      },
      {
        accessorKey: 'created_by_name',
        enableColumnFilter: false,
        size: 50,
        header: 'Created By',
      },
      {
        accessorKey: 'status',
        header: 'Status',
        size: 50,
        enableColumnFilter: true,
        enableSorting: false,
        filterFn: statusFilterFn,
        cell: ({ row }) => (
          <div className='flex justify-center'>
            <div 
              onClick={() => openStatusModal(row.original)} 
              className={`${row.original.status === 'active' ? 'bg-green-300  text-green-900' : 'bg-red-300 text-red-900'} text-xs w-fit px-2 py-1 font-bold rounded-xl cursor-default lg:cursor-pointer`}
            >
              {row.original.status === 'active' ? "Active" : "Inactive"}
            </div>
          </div>
        )
      },
      {
        accessorKey: 'id',
        header: 'Actions',
        size: 50,
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => {
          const clientMatch = client?.find((c) => c.client_code === row.original.client_id);
          return (
            <div className='flex gap-2 items-center justify-center'>
              <Menu as="div">
                <div ref={(el) => (buttonRefs.current[row.original.group_id] = el)}>
                  <Menu.Button className="border bg-gray-50 rounded-md p-1 text-blue-800 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      calculatePosition(row.original.group_id)
                    }}
                  >
                    <EllipsisHorizontalIcon className="h-4 text-black" />
                  </Menu.Button>
                </div>
                <Portal>
                  <Transition
                    as={Fragment}
                    show={activeDropdown === row.original.group_id}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute z-30 right-8 md:right-12 mt-1 w-fit rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                      style={{
                        top: `${dropdownPosition.top}px`,
                      }}
                      ref={dropdownRef}
                    >
                      <button
                        className="flex items-center px-4 py-2 hover:bg-gray-200 hover:text-blue-800 w-full text-sm disabled:text-gray-400"
                        // disabled={!clientMatch || row.original.status === 'inactive'}
                        onClick={() => {
                          openModal(row.original, "edit")
                          setActiveDropdown(null)
                        }}
                      >
                        <PencilIcon className={`h-4 ${(!clientMatch || row.original.status === 'inactive') ? 'text-gray-400' : 'text-blue-800'} mr-2`} />
                        <span>Edit</span>
                      </button>
                      {localStorage.getItem('role') === 'ADMIN' &&
                        <button className="flex items-center px-4 py-2 hover:bg-gray-200 hover:text-red-800 w-full text-sm"
                          onClick={() => {
                            openConfirmPopup(row.original)
                            setActiveDropdown(null)
                          }}>
                          <TrashIcon className='h-4 text-red-800 mr-2' />
                          <span>Delete</span>
                        </button>}
                    </Menu.Items>
                  </Transition>
                </Portal>
              </Menu>
            </div>
          )
        }
      },
    ].filter(Boolean),
    [client, activeDropdown, calculatePosition, dropdownPosition.top, statusFilterFn, clientFilterFn]
  );

  const [globalFilter, setGlobalFilter] = React.useState('');
  const [pageIndex, setPageIndex] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(initialpageSize);

  const pagination = React.useMemo(
    () => ({
      pageIndex,
      pageSize,
    }),
    [pageIndex, pageSize]
  )

  const table = useReactTable({
    data: projectGroups || [],
    columns,
    state: {
      sorting,
      pagination,
      globalFilter
    },
    onGlobalFilterChange: setGlobalFilter,
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues()
  });

  const tableContainerRef = React.useRef(null);
  const pageCount = Math.ceil(projectGroups.length / pageSize);
  const pageNumbers = [];

  for (let i = 0; i < pageCount; i++) {
    pageNumbers.push(i);
  }

  const handlePageChange = (e) => {
    const newPageSize = Number(e.target.value);
    setPageSize(newPageSize);
    setPageIndex(0)
  };

  const { rows } = table.getRowModel();
  // const rowVirtualizer = useVirtualizer({
  //   parentRef: tableContainerRef,
  //   size: rows.length,
  //   overscan: pageSize,
  // });
  const rowVirtualizer = useVirtualizer({
    count: rows.length,
    getScrollElement: () => scrollRef.current,
    estimateSize: () => 48, // Estimated row height in pixels
    overscan: 10 // Number of items to render outside visible area
  });
  // const { virtualItems: virtualRows, totalSize } = rowVirtualizer;

  const virtualRows = rowVirtualizer.getVirtualItems();
  const totalSize = rowVirtualizer.getTotalSize();

  // ✅ FIX 3: Safe padding calculations
  const paddingTop = virtualRows.length > 0 ? (virtualRows[0]?.start || 0) : 0;
  const paddingBottom = virtualRows.length > 0
    ? totalSize - (virtualRows[virtualRows.length - 1]?.end || 0)
    : 0;

  const renderTableCellIndex = (row) => {
    return (
      table.getFilteredRowModel().rows.indexOf(row) + 1 ||
      table.getSortedRowModel().rows.indexOf(row) + 1 ||
      row.index + 1
    );
  };

  // useEffect(() => {
  //   const fetchInitialData = async () => {
  //     axios
  //       .post(`${PROJECT_URL}/projects/groups/list`, {
  //         userInfo: getUserInfo(),
  //         payload: {}
  //       }, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //         }
  //       })
  //       .then((response) => {
  //         setData(response.data);
  //       })
  //       .catch((error) => {
  //         const errorMessage = handleApiError(error);
  //         setMsg(errorMessage);
  //         openPopup();
  //       })
  //       .finally(() => {
  //         setTimeout(() => {
  //           setLoader(false);
  //         }, 100);
  //       });
  //   };
  //   const fetchClientData = async () => {

  //     axios
  //       .get(`${FUNCTION_BASE_URL}/clients?code=${FUNCTION_CODE}`, {
  //       // .get(`${ONBOARD_URL}/clients`, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //           "x-resource-group": localStorage.getItem("resource_group"),
  //         },
  //       })
  //       .then((response) => {
  //         const filteredClients = response.data.data.filter(client => client.status === true);
  //         setClient(filteredClients);
  //       })
  //       .catch((error) => {
  //         const errorMessage = handleApiError(error);
  //         setMsg(errorMessage);
  //         openPopup();
  //       })
  //       .finally(() => {
  //         setTimeout(() => {
  //           setLoader(false);
  //         }, 100);
  //       });
  //   };
  //   fetchClientData();
  //   fetchInitialData();
  // }, []);

  useEffect(() => {
    const fetchInitialData = async () => {
      console.log("🚀 Fetching initial data...");
      axios
        .post(`${PROJECT_URL}/projects/groups/list`, {
          userInfo: getUserInfo(),
          payload: {}
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          }
        })
        .then((response) => {
          // setData(response.data);
          // console.log("👉 API Group List:", response.data.data.project_grp_list);
          console.log("API RAW RESPONSE:", response);

          const groups = response.data || [];
          console.log("🚀 Groups:", groups);
          setProjectGroups(groups);
        })
        .catch((error) => {
          console.error("🚀 Error fetching project groups:", error);
          const errorMessage = handleApiError(error);
          setMsg(errorMessage);
          openPopup();
        })
        .finally(() => {
          setTimeout(() => setLoader(false), 100);
        });
    };

    const fetchClientData = async () => {
      axios
        .get(`${FUNCTION_BASE_URL}/clients?code=${FUNCTION_CODE}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-resource-group": localStorage.getItem("resource_group"),
          },
        })
        .then((response) => {
          const filteredClients = response.data.data.filter(c => c.status === true);
          setClient(filteredClients);
        })
        .catch((error) => {
          const errorMessage = handleApiError(error);
          setMsg(errorMessage);
          openPopup();
        })
        .finally(() => {
          setTimeout(() => setLoader(false), 100);
        });
    };

    const role = localStorage.getItem("role");

    // ✔️ Only SuperAdmin should fetch client list
    if (role === "SuperAdmin") {
      fetchClientData();
    }

    // ✔️ ProjectAdmin also needs only project groups list
    fetchInitialData();
  }, []);
  // useEffect(() => {
  //   const fetchInitialData = async () => {
  //     console.log("🧪 TEST MODE: Bypassing APIM - Fetching initial data...");
  //     const CONTAINER_URL = "https://ixo-meghnadnext-app-pm-dev-01.calmfield-02780d18.centralindia.azurecontainerapps.io";
      
  //     // ✅ BYPASS APIM - Call backend directly
  //     // const DIRECT_BACKEND_URL = "http://localhost:8004"; // ← Change to your backend URL
  //     // const DIRECT_BACKEND_URL = "https://ixo-meghnadnext-apim-dev-01.azure-api.net/pm";
      
  //     const testPayload = {
  //       userInfo: {
  //         _id: sessionStorage.getItem("userid"),
  //         clientId: sessionStorage.getItem('client'),
  //         role: sessionStorage.getItem('role') || "ProjectAdmin",
  //         rg_name: sessionStorage.getItem('resource_group') || localStorage.getItem('resource_group')
  //       },
  //       payload: {}
  //     };
      
  //     console.log("🧪 Test Payload:", testPayload);
  //     console.log("🧪 Calling URL:", `${PROJECT_URL}/projects/groups/list-direct-test`);
      
  //     axios
  //       .post(`${CONTAINER_URL}/projects/groups/list-direct-test`, testPayload, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           // ❌ NO Authorization header for test
  //         }
  //       })
  //       .then((response) => {
  //         console.log("✅ Direct endpoint SUCCESS!");
  //         console.log("API RAW RESPONSE:", response);

  //         const groups = response.data || [];
  //         console.log("🚀 Groups:", groups);
  //         setProjectGroups(groups);
  //       })
  //       .catch((error) => {
  //         console.error("❌ Direct endpoint FAILED:", error);
  //         console.error("Error details:", error.response?.data);
  //         const errorMessage = handleApiError(error);
  //         setMsg(errorMessage);
  //         openPopup();
  //       })
  //       .finally(() => {
  //         setTimeout(() => setLoader(false), 100);
  //       });
  //   };

  //   const fetchClientData = async () => {
  //     axios
  //       .get(`${FUNCTION_BASE_URL}/clients?code=${FUNCTION_CODE}`, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //           "x-resource-group": localStorage.getItem("resource_group"),
  //         },
  //       })
  //       .then((response) => {
  //         const filteredClients = response.data.data.filter(c => c.status === true);
  //         setClient(filteredClients);
  //       })
  //       .catch((error) => {
  //         const errorMessage = handleApiError(error);
  //         setMsg(errorMessage);
  //         openPopup();
  //       })
  //       .finally(() => {
  //         setTimeout(() => setLoader(false), 100);
  //       });
  //   };

  //   const role = localStorage.getItem("role");

  //   if (role === "SuperAdmin") {
  //     fetchClientData();
  //   }

  //   fetchInitialData();
  // }, []);

  return (
    <div className="border rounded-lg bg-white font-GoogleSans tracking-wider overflow-hidden">
      <ConfirmationPopup
        isOpenConfirmPopup={isOpenConfirmPopup}
        confirmationMsg={confirmationMsg}
        closeConfirmPopup={closeConfirmPopup}
        onStateChange={handleDeleteState}
      />
      <Popup
        isOpen={isOpenPopup}
        msg={msg}
        closeModal={closePopup}
        isSuccess={isSuccess}
      />
      <InputModal isOpen={isOpen} closeModal={closeModal} title={edit === false ? 'Create project group' : 'Edit project group'} savefn={edit === false ? handleCreateState : handleEditState}
        modalInputs={
          <div className='space-y-4'>
            {localStorage.getItem('role') === 'ADMIN' &&
              <div>
                <label htmlFor="client" className="block text-sm font-medium leading-6 text-gray-900">
                  Client
                </label>
                <select
                  id="client"
                  name="client"
                  required
                  className="block w-auto md:w-full rounded-md border-0 py-2 mt-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs lg:max-w-full sm:text-sm sm:leading-6"
                  value={rowData.client_code}
                  onChange={(e) => setRowData({ ...rowData, client_code: e.target.value })}
                >
                  <option value="">Select Client</option>
                  {client.map((item, index) => (
                    <option key={index} value={item.client_code}>
                      {item.client_name}
                    </option>
                  ))}
                </select>
              </div>}
            <div>
              <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
                Group Name
              </label>
              <input 
                type="text" 
                maxLength={50}
                className='block w-full rounded-md border py-1.5 mt-1 ring-0 sm:text-sm sm:leading-6' 
                defaultValue={rowData.name} 
                onChange={(e) => setRowData({ ...rowData, name: e.target.value })} 
              />
            </div>
            <div>
              <label htmlFor="description" className="block text-sm font-medium leading-6 text-gray-900">
                Description
              </label>
              <textarea 
                id="description"
                rows="3"
                className='block w-full rounded-md border py-1.5 mt-1 ring-0 sm:text-sm sm:leading-6' 
                defaultValue={rowData.description} 
                onChange={(e) => setRowData({ ...rowData, description: e.target.value })} 
              />
            </div>
            {/* <div>
              <label htmlFor="tags" className="block text-sm font-medium leading-6 text-gray-900">
                Tags (comma separated)
              </label>
              <input 
                type="text" 
                id="tags"
                placeholder="high-priority, strategic, Q1-2024"
                className='block w-full rounded-md border py-1.5 mt-1 ring-0 sm:text-sm sm:leading-6' 
                defaultValue={rowData.tags?.join(', ')} 
                onChange={(e) => setRowData({ ...rowData, tags: e.target.value.split(',').map(tag => tag.trim()) })} 
              />
            </div> */}
          </div>
        }
      />
      {/* <InputModal isOpen={isOpenStatusModal} closeModal={closeStatusModal} title={modalTitle} savefn={handleStatusState}
        modalInputs={
          <div className='flex gap-5'>
            <div className="flex items-center gap-x-2">
              <input
                id="status"
                name="status"
                type="radio"
                value="true"
                // checked={rowData.status === true || rowData.status === "true" || rowData.status === "active"}
                checked={rowData.status === "active"}
                onChange={(e) =>
                  setRowData({
                    ...rowData,
                    status: e.target.value,
                  })
                }
                autoFocus={false}
                className="h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none"
              />
              <label htmlFor="push-everything" className="block text-sm font-medium leading-6 text-gray-900">
                Active
              </label>
            </div>
            <div className="flex items-center gap-x-2">
              <input
                id="status"
                name="status"
                type="radio"
                value="false"
                // checked={rowData.status === false || rowData.status === "false" || rowData.status === "inactive"}
                checked={rowData.status === "inactive"}
                onChange={(e) =>
                  setRowData({
                    ...rowData,
                    status: e.target.value,
                  })
                }
                autoFocus={false}
                className="h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none"
              />
              <label htmlFor="push-email" className="block text-sm font-medium leading-6 text-gray-900">
                Inactive
              </label>
            </div>
          </div>
        }
      /> */}

      <InputModal 
        isOpen={isOpenStatusModal} 
        closeModal={closeStatusModal} 
        title={modalTitle} 
        savefn={handleStatusState}
        modalInputs={
          <div className='flex gap-5'>
            <div className="flex items-center gap-x-2">
              <input
                id="status-active"
                name="status"
                type="radio"
                value="active"
                checked={rowData.status === "active"}
                onChange={(e) =>
                  setRowData({
                    ...rowData,
                    status: e.target.value,
                  })
                }
                autoFocus={false}
                className="h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none"
              />
              <label htmlFor="status-active" className="block text-sm font-medium leading-6 text-gray-900">
                Active
              </label>
            </div>
            <div className="flex items-center gap-x-2">
              <input
                id="status-inactive"
                name="status"
                type="radio"
                value="inactive"
                checked={rowData.status === "inactive"}
                onChange={(e) =>
                  setRowData({
                    ...rowData,
                    status: e.target.value,
                  })
                }
                autoFocus={false}
                className="h-4 w-4 border-gray-300 text-indigo-600 focus:outline-none focus:ring-0 focus:border-none"
              />
              <label htmlFor="status-inactive" className="block text-sm font-medium leading-6 text-gray-900">
                Inactive
              </label>
            </div>
          </div>
        }
      />

      <div className='flex justify-between m-3 gap-2'>
        <div>
          <DebouncedInput
            value={globalFilter ?? ''}
            onChange={value => setGlobalFilter(String(value))}
            placeholder="Search..."
          />
        </div>
        <div className='flex gap-2'>
          <button className="rounded-md cursor-default lg:cursor-pointer p-2 inline-flex text-sm border-gray-300 border" onClick={() => ReloadData(true)}>
            <ArrowPathIcon className='h-5 text-green-700' />
          </button>
          <Menu as="div" className="relative">
            <div>
              <Menu.Button className="relative justify-center border border-gray-300 rounded-md p-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-default lg:cursor-pointer">
                <span className="absolute -inset-1.5" />
                <FunnelIcon className="h-5 w-auto" />
              </Menu.Button>
            </div>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="fixed right-8 z-30 mt-3 w-fit px-2 pb-2 space-y-3 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div>
                  {projectGroups.length > 0 &&
                    table
                      .getHeaderGroups()
                      .map((headerGroup) => (
                        <div
                          key={headerGroup.id}
                          className="space-y-1"
                        >
                          {headerGroup.headers.map(
                            (header) => (
                              <div
                                key={header.id}
                              >
                                {header.column.getCanFilter() &&
                                  header.column.id === "status" ? (
                                  <div>
                                    <label
                                      htmlFor="push-everything"
                                      className="block text-xs font-bold tracking-widest leading-6 text-gray-400 ps-1"
                                    >
                                      Status
                                    </label>
                                    <StatusAdminFilter
                                      column={
                                        header.column
                                      }
                                      table={
                                        table
                                      }
                                    />
                                  </div>
                                ) : null}
                                {header.column.getCanFilter() &&
                                  header.column
                                    .id ===
                                  "client_id" ? (
                                  <div>
                                    <label
                                      htmlFor="push-everything"
                                      className="block text-xs font-bold tracking-widest leading-6 text-gray-400 ps-1"
                                    >
                                      Client
                                    </label>
                                    <SelectTextFilterWithAllOption
                                      column={
                                        header.column
                                      }
                                      table={
                                        table
                                      }
                                    />
                                  </div>
                                ) : null}
                              </div>
                            )
                          )}
                        </div>
                      ))}
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
          <button className="rounded-md cursor-default lg:cursor-pointer p-2 inline-flex text-sm border-gray-300 border" onClick={() => openModal('e', 'create')}>
            <PlusCircleIcon className='h-5' />
          </button>
        </div>
      </div>
      {Loader && <FetchingDataLoader />}
      {!Loader &&
        <>
          <div ref={scrollRef} className='resp-table-h border-y overflow-auto relative' style={{ height: '600px' }} >
            <table className='flex-inline w-full border-collapse'>
              <thead className='bg-gray-100'>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => {
                      return (
                        <th
                          className='border p-2 whitespace-nowrap'
                          key={header.id}
                          colSpan={header.colSpan}
                          style={{ width: header.getSize() }}
                        >
                          {header.isPlaceholder ? null : (
                            <>
                              <div
                                className={`${header.column.getCanSort()
                                  ? 'cursor-pointer select-none justify-start'
                                  : 'justify-center'
                                  } flex`}
                                onClick={header.column.getToggleSortingHandler()}
                              >
                                {flexRender(
                                  header.column.columnDef.header,
                                  header.getContext()
                                )}
                                {{
                                  asc: ' 🔼',
                                  desc: ' 🔽',
                                }[header.column.getIsSorted()] || null}
                              </div>
                            </>
                          )}
                        </th>
                      );
                    })}
                  </tr>
                ))}
              </thead>
              <tbody>
                {
                  rows.length === 0 ? (
                    <tr>
                      <td className='border p-2' colSpan={table.getHeaderGroups()[0].headers.length} style={{ textAlign: 'center' }}>
                        No Data Found
                      </td>
                    </tr>
                  ) :
                    (
                      <>
                        {paddingTop > 0 && (
                          <tr>
                            <td className='border p-2' style={{ height: `${paddingTop}px` }} />
                          </tr>
                        )}
                        {/* {virtualRows.map((virtualRow) => {
                          const row = rows[virtualRow.index];
                          return (
                            <tr key={row.id}>
                              {row.getVisibleCells().map((cell) => {
                                return (
                                  <td className='border p-2 whitespace-nowrap' key={cell.id}>
                                    {cell.column.id === "index" && (
                                      <center>{renderTableCellIndex(row)}</center>
                                    )}
                                    {cell.column.id !== "index" &&
                                      flexRender(
                                        cell.column
                                          .columnDef
                                          .cell,
                                        cell.getContext()
                                      )}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })} */}
                        {virtualRows.map((virtualRow) => {
                          const row = rows[virtualRow.index];
                          if (!row) return null; // Safety check
                          
                          return (
                            <tr key={row.id}>
                              {row.getVisibleCells().map((cell) => (
                                <td 
                                  className='border p-2 whitespace-nowrap' 
                                  key={cell.id}
                                >
                                  {cell.column.id === "index" ? (
                                    <center>{renderTableCellIndex(row)}</center>
                                  ) : (
                                    flexRender(
                                      cell.column.columnDef.cell,
                                      cell.getContext()
                                    )
                                  )}
                                </td>
                              ))}
                            </tr>
                          );
                        })}
                        {paddingBottom > 0 && (
                          <tr>
                            <td className='border p-2' style={{ height: `${paddingBottom}px` }} />
                          </tr>
                        )}
                      </>
                    )
                }

              </tbody>
            </table>
          </div>
          {
            rows.length > 0 && (
              <div className='flex gap-1 flex-wrap md:flex-nowrap justify-between flex-row-reverse m-3'>
                <Pagination
                  pageIndex={pageIndex}
                  setPageIndex={setPageIndex}
                  pageNumbers={pageNumbers}
                  pageCount={table.getPageCount()}
                />
                <PageSizeDropdown
                  dataLength={table.getPrePaginationRowModel().rows.length}
                  pageSize={pageSize}
                  handlePageChange={handlePageChange}
                  totalRows={table.getPrePaginationRowModel().rows.length}
                />
              </div>
            )
          }
        </>
      }
    </div>
  );
}